export default __webpack_public_path__ + "static/blueberry-819fcbb0d31165831ea037946828aac7.png";